'use client';
export const LangText: any = {
    us: {
        alsoNeed: 'You may also need:',
        affirm1: '*Six interest-free installments',
        Now: 'Now',
        MSRP: 'MSRP',
    },
    jp: {
        alsoNeed: 'You may also need:',
        affirm1: '*Six interest-free installments',
        Now: '限定価格',
        MSRP: '通常価格',
    },
};
